import moment from 'moment';
import {GENDER, WORK_FORM, WORK_FORM_STRING, GENDER_STRING, USER_TYPE, USER_TYPE_STRING,PATTERN_STRING_ONLY} from '../configs/constants';
/* eslint-disable no-useless-escape */
export const getStringAfterLastSlash = (str = '', char = '.', removeQuery = false) => {
    if (!str) return '';
    const n = str.lastIndexOf(char);
    let converted = str.substring(n + 1);
    if (removeQuery && converted.includes('?')) {
        converted = converted.split('?')[0] || ''
    }
    return converted;
};
  
export function generateRandomKey(max = 6) {
    // Declare a digits variable
    // which stores all digits
    var digits = '0123456789';
    let key = '';
    for (let i = 0; i < max; i++) {
        key += digits[Math.floor(Math.random() * 10)];
    }
    return key;
}

export function numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function renameKeysObject(keysMap, objectData) {
    return Object.keys(objectData).reduce(
        (acc, key) => ({
            ...acc,
            ...{ [keysMap[key] || key]: objectData[key] }
        }),
        {}
    );
}

export function arrayUniqueByKey(arr = [], key = 'id') {
    return [...new Map(arr.map(item => [item[key], item])).values()];
}

export const handleKeyPressForNumber = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!/^([0-9])*$/.test(keyValue)) {
        event.preventDefault();
    }
}

export const handlePasteForNumber = (event) => {
    if (!event.clipboardData.getData('text/plain').match(/^([0-9])*$/)) {
        event.preventDefault();
    }
}

export const handleKeyPressForHiragana = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!/^([-!$%^&*()_+|~=`{}[\]:\/;<>?,.@#0-9])+$/.test(keyValue)) {
        event.preventDefault();
    }
}

export const handlePasteForHiragana = (event) => {
    if (!event.clipboardData.getData('text/plain').match(/^[-!$%^&*()_+|~=`{}[\]:\/;<>?,.@#0-9]/)) {
        event.preventDefault();
    }
}

///Hiragana, fullwidth Katakana characters
export const handleKeyPressJapanText = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!/^[ぁ-んァ-ン]+$/.test(keyValue)) {
        event.preventDefault();
    }
}
///Hiragana, fullwidth Katakana characters
export const handlePasteJapanText = (event) => {
    if (!event.clipboardData.getData('text/plain').match(/^[ぁ-んァ-ン]+$/)) {
        console.log('bem');
        event.preventDefault();
    }
}

///Hiragana, Katakana, number characters
export const HKNumberReg = /^[ぁ-んァ-ン0-9]*$/;
export const handleKeyPressHKNumberText = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!HKNumberReg.test(keyValue)) {
        event.preventDefault();
    }
}

///Hiragana, Katakana, number characters
export const handlePasteHKNumberText = (event) => {
    if (!event.clipboardData.getData('text/plain').match(HKNumberReg)) {
        event.preventDefault();
    }
}

///Katakana, number characters
export const KataNumberReg = /^(([ァ-ン]|ー)|[0-9])*$/;
export const handleKeyPressKataNumberText = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!KataNumberReg.test(keyValue)) {
        event.preventDefault();
    }
}

///Katakana, number characters
export const handlePasteKataNumberText = (event) => {
    if (!event.clipboardData.getData('text/plain').match(KataNumberReg)) {
        event.preventDefault();
    }
}

///Latin and Kanji characters
export const KanjiLatinhReg = /^([一-龥]|[a-zA-Z0-9 ])*$/;
export const handleKeyPressLatinText = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!KanjiLatinhReg.test(keyValue)) {
        event.preventDefault();
    }
}
///Latin and Kanji characters
export const handlePasteLatinText = (event) => {
    if (!event.clipboardData.getData('text/plain').match(KanjiLatinhReg)) {
        event.preventDefault();
    }
}

export const getFileExtension = (filename) => {
    let ext = /^.+\.([^.]+)$/.exec(filename)
    return ext == null ? '' : `.${ext[1].toLowerCase()}`
}


export function isOtherNumber(c) {
    //eslint-disable-next-line
    var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (format.test(c)) {
        return format.test(c);
    }
    if (c.length != 1 || c == '_' || c == '$') return false;
    if (c.toUpperCase() != c.toLowerCase()) return true;
    if (c.charCodeAt(0) < 128) return false;
    try {
        eval('function ' + c + '(){}');
        return true;
    } catch {
        return false;
    }
}

export const spliceIntoChunks = (arr, chunkSize) => {
    const res = [];
    while (arr.length > 0) {
        const chunk = arr.splice(0, chunkSize);
        res.push(chunk);
    }
    return res;
}

export const extractContent = (html = null) => {
    if(!html) return ''; 

    return new DOMParser()
        .parseFromString(html, 'text/html')
        .documentElement.textContent;
}

export function truncateByWords(str = '', index = 120) {
    if (!str) {
        return {
            showMore: false,
            text: ''
        };
    }

    return {
        showMore: str.length > index,
        text: str.length > index ?  str.substring(0, index) + '...' : str
    }
}

export const getGenderName = (status) => {
    switch (status) {
    case GENDER.MALE:
        return GENDER_STRING.MALE;
    case GENDER.FEMALE:
        return GENDER_STRING.FEMALE;
    default:
        return '';
    }
}

export const getWorkFormName = (workForm) => {
    switch (workForm) {
    case WORK_FORM.OFFSHORE:
        return WORK_FORM_STRING.OFFSHORE;
    case WORK_FORM.OUTSIDE:
        return WORK_FORM_STRING.OUTSIDE;
    case WORK_FORM.OTHER:
        return WORK_FORM_STRING.OTHER;
    default:
        return WORK_FORM_STRING.OTHER;
    }
}

export const getUserTypeName = (type) => {
    switch (type) {
    case USER_TYPE.GROUP_MANAGER:
        return USER_TYPE_STRING.GROUP_MANAGER;
    case USER_TYPE.JIHOU_ADMINISTRATOR:
        return USER_TYPE_STRING.JIHOU_ADMINISTRATOR;
    case USER_TYPE.STUDENT_GROUP:
        return USER_TYPE_STRING.STUDENT_GROUP;
    case USER_TYPE.STUDENT_INDIVIDUAL:
        return USER_TYPE_STRING.STUDENT_INDIVIDUAL;
    default:
        return '';
    }
}

export const handlePasteNumberField =(event) => {
    if (!event.clipboardData.getData('text/plain').match(PATTERN_STRING_ONLY)) {
        event.preventDefault();
    }
}

export const convertVideoDuration = (duration) => {
    return duration !== undefined && duration !== 0 ? numberWithCommas(Math.round(duration / 60)) : (duration || 0)
}

export const getDatesDifferenceTwoDates = (startDate, endDate) => {
    if(!startDate || !endDate) return 0;
    const duration = moment.duration(moment(endDate).diff(moment(startDate)));
    return duration.asDays();
}

export const getFileNameFromUrl = (url) => {
    const parts = url?.split('/');
    return parts?.length > 0 ? parts[parts.length - 1] : '';
};

export const formatTimeFromVideoLength = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

export const splitFileName = (fileName) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) return { name: fileName, ext: '' };

    return {
        name: fileName.slice(0, lastDotIndex),
        ext: fileName.slice(lastDotIndex + 1)
    };
}

export const formatBytes = (size, units = null) => {
    const defaultUnits = ['B', 'KB', 'MB', 'GB', 'TB'];
    units = units || defaultUnits;

    if (size < 0 || isNaN(size)) return '0 ' + units[0];

    let base = 1;
    if (units[0] === 'KB') base = 1024;
    else if (units[0] === 'MB') base = 1024 * 1024;
    else if (units[0] === 'GB') base = 1024 * 1024 * 1024;
    else if (units[0] === 'TB') base = 1024 * 1024 * 1024 * 1024;

    size /= base;

    let unitIndex = 0;
    while (size >= 1024 && unitIndex < units.length - 1) {
        size /= 1024;
        unitIndex += 1;
    }

    return parseFloat(size.toFixed(2)) + ' ' + units[unitIndex];
};

export const downloadFileBySignedUrl = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_self';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const extractFileNameAndExt = (fullName) => {
    const lastDotIndex = fullName.lastIndexOf('.');

    if (lastDotIndex === -1) {
        return {
            name: fullName,
            extension: ''
        };
    }

    const name = fullName.substring(0, lastDotIndex);
    const extension = fullName.substring(lastDotIndex + 1).toLowerCase();
    return {
        name,
        extension
    };
};


export const convertBytesToMbOrGb = (bytes) => {
    const gb = bytes / 1024 ** 3;
    if (gb >= 1) {
        return { value: parseFloat(gb.toFixed(2)), unit: 'GB' };
    }

    const mb = bytes / 1024 ** 2;
    return { value: parseFloat(mb.toFixed(2)), unit: 'MB' };
};
export const formatDecimal = (number) => {
    const rounded = Math.round(number * 100) / 100;
  
    if (Number.isInteger(rounded)) {
        return rounded.toString();
    }
  
    return rounded.toString();
}

export const formatScheduledPublishDateJP = (date) => {
    if (!date) return '';

    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');

    return `${year}年${month}月${day}日公開予定`;
};
export const getTodayInJP = () => {
    const now = new Date();
    const jpTime = new Date(
        now.toLocaleString('en-US', { timeZone: 'Asia/Tokyo' })
    );
    jpTime.setHours(0, 0, 0, 0); 
    return jpTime;
};

export const isPublicDateAfterTodayJP = (publicDate) => {
    if (!publicDate) return false;

    const publishDate = new Date(publicDate);
    publishDate.setHours(0, 0, 0, 0);

    const todayJP = getTodayInJP();

    return publishDate > todayJP;
};
export const formatCountDown = (totalSeconds) => {
    if (totalSeconds <= 0) return '';

    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = Math.floor(totalSeconds % 60);

    const pad = (n) => n.toString().padStart(2, '0');

    if (h > 0) {
        return `${h}:${pad(m)}:${pad(s)}`;
    }
    
    if (m > 0) {
        return `${m}:${pad(s)}`;
    }

    return `${s}`;
};